'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UISelect from 'UIComponents/input/UISelect';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { isAutomatedAb } from 'EmailData/utils/details/abEmailUtil';
import { AB_SELECT_VALUE } from 'EmailData/constants/details/abEmailConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function isVersionWinner(emailDetails, version) {
  const automatedAb = isAutomatedAb(emailDetails);
  if (automatedAb) {
    return emailDetails.isEmailWinner(version);
  }
  return emailDetails.getWinningVariantType() === version;
}
function AbOptionSelect({
  emailDetails,
  overrideCloneOptions
}) {
  const hasABWinner = emailDetails.hasWinner();
  const isInconclusive = emailDetails.isInconclusive();
  const automatedAb = isAutomatedAb(emailDetails);
  const masterKey = hasABWinner && isVersionWinner(emailDetails, AB_SELECT_VALUE.A) ? 'EmailComponents.modals.clone.abOptions.CLONE_AB_MASTER_WINNER' : 'EmailComponents.modals.clone.abOptions.CLONE_AB_MASTER';
  const variantKey = hasABWinner && isVersionWinner(emailDetails, AB_SELECT_VALUE.B) ? 'EmailComponents.modals.clone.abOptions.CLONE_AB_VARIANT_WINNER' : 'EmailComponents.modals.clone.abOptions.CLONE_AB_VARIANT';
  const emailCloneAbOptions = [{
    text: I18n.text(masterKey),
    title: I18n.text(masterKey),
    value: AB_SELECT_VALUE.A,
    help: I18n.text(automatedAb ? 'EmailComponents.modals.clone.abOptions.automated' : 'EmailComponents.modals.clone.abOptions.regular')
  }, {
    text: I18n.text(variantKey),
    title: I18n.text(variantKey),
    value: AB_SELECT_VALUE.B,
    help: I18n.text(automatedAb ? 'EmailComponents.modals.clone.abOptions.automated' : 'EmailComponents.modals.clone.abOptions.regular')
  }, {
    text: I18n.text('EmailComponents.modals.clone.abOptions.CLONE_AB'),
    title: I18n.text('EmailComponents.modals.clone.abOptions.CLONE_AB'),
    value: AB_SELECT_VALUE.AB,
    disabled: hasABWinner,
    tooltip: 'EmailComponents.modals.clone.abOptions.abCloneDisabled',
    help: I18n.text(automatedAb ? 'EmailComponents.modals.clone.abOptions.automatedAb' : 'EmailComponents.modals.clone.abOptions.regularAb')
  }];
  const tooltipWrappedOptions = ({
    children,
    option
  }) => /*#__PURE__*/_jsx(UITooltip, {
    placement: "left",
    title: option.tooltip ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: option.tooltip
    }) : undefined,
    disabled: !option.disabled,
    children: children
  });
  const onSelectAbOption = e => {
    const abCloneOptionsValue = {
      variantOnly: e.target.value !== AB_SELECT_VALUE.AB,
      contentId: e.target.value !== AB_SELECT_VALUE.B ? emailDetails.getLastTestPrimaryEmail().id : emailDetails.getLastTestVariantEmail().id
    };
    overrideCloneOptions(true, abCloneOptionsValue);
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    "data-test-id": "clone-modal-ab-option-select",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "EmailComponents.modals.clone.abOptions.abEmailSelection"
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [!hasABWinner && !isInconclusive && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.modals.clone.abOptions.abTestRunningDescription"
      }), /*#__PURE__*/_jsx(UISelect, {
        itemComponent: tooltipWrappedOptions,
        onChange: onSelectAbOption,
        options: emailCloneAbOptions,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.modals.clone.abOptions.selectVersion"
        })
      })]
    })
  });
}
AbOptionSelect.propTypes = {
  emailDetails: PropTypes.object,
  overrideCloneOptions: PropTypes.func
};
export default AbOptionSelect;